import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';

// Make React and ReactDOM available globally for window components
window.React = React;
window.ReactDOM = ReactDOM;

// Global Email Validation Helper
window.validateEmail = function(email) {
  if (!email || typeof email !== 'string') return false;
  const trimmed = email.trim();
  // Standard RFC 5322 regex validation
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  if (!emailRegex.test(trimmed)) return false;

  const parts = trimmed.split('@');
  if (parts.length !== 2) return false;
  const domain = parts[1].toLowerCase();

  // Check valid TLD domain
  if (!domain.includes('.')) return false;
  const domainParts = domain.split('.');
  const tld = domainParts[domainParts.length - 1];
  if (!tld || tld.length < 2) return false;

  // Block obvious invalid test domain placeholders
  const blocked = ['example.com', 'test.com', 'invalid.com'];
  if (blocked.includes(domain)) return false;

  return true;
};

// Import API and Data modules
import './admin/apiClient.js';
import './utils/seoHelper.js';

// Import Components
import './components/Header.jsx';
import './components/Footer.jsx';
import './components/QuoteModal.jsx';

// Import Admin Panel Modules
import './admin/MediaPickerModal.jsx';
import './admin/AdminLogin.jsx';
import './admin/AdminLayout.jsx';
import './admin/AdminDashboard.jsx';
import './admin/AdminHomeFeatures.jsx';
import './admin/AdminIndustries.jsx';
import './admin/AdminProducts.jsx';
import './admin/AdminCategories.jsx';
import './admin/AdminCareers.jsx';
import './admin/AdminApplications.jsx';
import './admin/AdminInquiries.jsx';
import './admin/AdminBlogs.jsx';
import './admin/AdminNewsletter.jsx';
import './admin/AdminMedia.jsx';
import './admin/AdminContent.jsx';
import './admin/AdminUsers.jsx';
import './admin/AdminLogs.jsx';

// Import Pages
import './pages/HomePage.jsx';
import './pages/IndustriesPage.jsx';
import './pages/ProductsPage.jsx';
import './pages/ProductDetailPage.jsx';
import './pages/AboutPage.jsx';
import './pages/BlogsPage.jsx';
import './pages/CareersPage.jsx';
import './pages/ContactPage.jsx';
import './pages/SupportPage.jsx';
import './pages/LoginPage.jsx';
import './pages/IndiaPage.jsx';
import './pages/CategoryPage.jsx';

// Import App Root
import './App.jsx';

// Mount Application to #root
const rootElement = document.getElementById('root');
if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(React.createElement(window.App));
}
